export const maskCustomerPhone = (phone: string | undefined | null): string => {
    phone = phone ?? '';
    if (phone.length === 11) {
        return phone.replace(/^(\d{4})\d{3}(\d{3})$/, '$1***$2');
    } else if (phone.length >= 6) {
        return phone.slice(0, 4) + '***';
    } else if (phone.length > 0) {
        return phone.slice(0, 2) + '***';
    } else {
        return 'N/A';
    }
};

